import { render, staticRenderFns } from "./SafetyObservationItemOpenPendingListing.vue?vue&type=template&id=c1f13b26"
import script from "./SafetyObservationItemOpenPendingListing.vue?vue&type=script&lang=js"
export * from "./SafetyObservationItemOpenPendingListing.vue?vue&type=script&lang=js"
import style0 from "./SafetyObservationItemOpenPendingListing.vue?vue&type=style&index=0&id=c1f13b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports